<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <!-- breadcrumbs -->
      <Breadscrumbs
        :links="[
          {
            name: 'SubCategories',
            to: {
              name: 'SubCategories'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'SubCategoryCreate'
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增子分類</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!--  -->
    <SubCategoryEditCreate></SubCategoryEditCreate>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SubCategoryEditCreate from '@/views/C-2__SubCategory/c/SubCategoryEditCreate.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    SubCategoryEditCreate,
    Breadscrumbs,
  },
  computed: {
    ...mapState(['currentBuTabId']),
    ...mapState('subcategory', ['subcategory']),
  },
  created() {
    this.setSubCategory({
      bu_id: this.currentBuTabId,
      specs: [],
      filters: [],
    });
  },
  methods: {
    ...mapActions('subcategory', ['setSubCategory', 'save', 'clear']),
    cancelHandler() {
      this.$router.push({ name: 'SubCategories' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.subcategory.name) {
          this.errors.push('SubCategory Name required.');
        }
        if (!this.subcategory.bu_id) {
          this.errors.push('BU required.');
        }
        if (!this.subcategory.product_category_id) {
          this.errors.push('Category required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.subcategory).then(() => {
          this.$router.push({ name: 'SubCategories' });
          this.clear();
        });
      }
    },
  },
};
</script>